export const CHECKOUT_URL = 'https://torque-en.impultienda.ar/checkout/';

type Fbq = (...args: unknown[]) => void;

export function trackCheckout(): void {
  const fbq = (window as unknown as { fbq?: Fbq }).fbq;
  if (typeof fbq === 'function') {
    fbq('track', 'InitiateCheckout', { value: 27, currency: 'USD' });
  }
}
